// Mock data for RT BUSINESS website

export const mockData = {
  holding: {
    name: "RT BUSINESS",
    tagline: "Votre Partenaire en Solutions Télécoms",
    description: "RT BUSINESS est un groupe leader dans le déploiement et la maintenance de réseaux fibre optique, regroupant deux entités spécialisées : RT CONNECT et MRT+",
    email: "business@rtconnect.fr",
    address: "112 allée d'érable, Villepinte 93420",
    fullAddress: {
      street: "112 allée d'érable",
      city: "Villepinte",
      postalCode: "93420",
      country: "France"
    }
  },
  
  rtconnect: {
    name: "RT CONNECT",
    tagline: "votre réseau notre métier",
    email: "office@rtconnect.fr",
    description: "Expert en déploiement et maintenance de réseaux fibre optique avec une approche innovante et des solutions sur-mesure.",
    zones: "Paris et départements 92 et 77",
    zonesDetail: ["Paris (75)", "Hauts-de-Seine (92)", "Seine-et-Marne (77)"]
  },
  
  mrtplus: {
    name: "MRT+",
    tagline: "Excellence & Innovation",
    email: "office@rtconnect.fr",
    description: "Spécialiste des infrastructures télécoms avec un engagement fort pour la qualité et la performance de vos réseaux.",
    zones: "Normandie et Bretagne",
    zonesDetail: ["Normandie", "Bretagne"]
  },
  
  hero: {
    title: "Groupe RT BUSINESS",
    subtitle: "Leader en Solutions Fibre Optique & Télécommunications",
    description: "Deux marques d'excellence au service de vos infrastructures réseau : RT CONNECT et MRT+",
    cta: "Découvrir nos solutions",
    image: "https://images.unsplash.com/photo-1597733336794-12d05021d510?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxmaWJlciUyMG9wdGljJTIwbmV0d29ya3xlbnwwfHx8fDE3NzM0MTkwODN8MA&ixlib=rb-4.1.0&q=85"
  },
  
  services: [
    {
      id: 1,
      title: "Déploiement de Réseaux",
      description: "Installation complète de réseaux fibre optique FTTH, FTTB et FTTE. Nous gérons vos projets de A à Z avec une expertise technique reconnue.",
      icon: "Network",
      image: "https://images.unsplash.com/photo-1594915854088-2128db6a8db5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxmaWJlciUyMG9wdGljJTIwbmV0d29ya3xlbnwwfHx8fDE3NzM0MTkwODN8MA&ixlib=rb-4.1.0&q=85",
      features: [
        "Installation FTTH/FTTB/FTTE",
        "Raccordement points de branchement",
        "Tirage et pose de câbles",
        "Mise en service et tests"
      ]
    },
    {
      id: 2,
      title: "Maintenance & Support",
      description: "Service de maintenance préventive et corrective pour garantir la performance optimale de vos infrastructures réseau.",
      icon: "Wrench",
      image: "https://images.unsplash.com/photo-1594915440248-1e419eba6611?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxmaWJlciUyMG9wdGljJTIwbmV0d29ya3xlbnwwfHx8fDE3NzM0MTkwODN8MA&ixlib=rb-4.1.0&q=85",
      features: [
        "Maintenance préventive",
        "Dépannage 24/7",
        "Diagnostic et réparation",
        "Support technique"
      ]
    },
    {
      id: 3,
      title: "Infrastructure Réseau",
      description: "Conception et déploiement d'infrastructures réseau complètes adaptées à vos besoins spécifiques.",
      icon: "Radio",
      image: "https://images.unsplash.com/photo-1703113690885-8caf0c77a7cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxuZXR3b3JrJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc3MzQxOTEwMHww&ixlib=rb-4.1.0&q=85",
      features: [
        "Étude et conception",
        "Déploiement infrastructure",
        "Configuration réseau",
        "Optimisation performance"
      ]
    }
  ],
  
  clients: [
    {
      id: 1,
      name: "Circet",
      logo: "https://customer-assets.emergentagent.com/job_fiber-solutions-rt/artifacts/vha42s5f_csm_CIRCET_France_b60b6c9298.jpg",
      description: "Leader européen des services réseau"
    },
    {
      id: 2,
      name: "Kyntus",
      logo: "https://customer-assets.emergentagent.com/job_fiber-solutions-rt/artifacts/spufv8gt_images.png",
      description: "Expert en télécommunications"
    },
    {
      id: 3,
      name: "Sogetrel",
      logo: "https://customer-assets.emergentagent.com/job_fiber-solutions-rt/artifacts/4tuqr7r6_idEcqUs1Kp_1773423831188.png",
      description: "Solutions d'infrastructure digitale"
    }
  ],
  
  about: {
    title: "À Propos du Groupe RT BUSINESS",
    subtitle: "Votre Partenaire de Confiance",
    description: "RT BUSINESS est un groupe leader spécialisé dans le déploiement et la maintenance de réseaux fibre optique. À travers nos deux entités RT CONNECT et MRT+, nous intervenons sur l'ensemble du territoire pour accompagner nos clients dans leurs projets de télécommunication avec excellence et professionnalisme.",
    mission: "Notre mission est de fournir des solutions de connectivité fibre optique de haute qualité, en garantissant excellence technique, respect des délais et satisfaction client à travers nos deux marques complémentaires.",
    stats: [
      { number: "500+", label: "Projets Réalisés" },
      { number: "50+", label: "Clients Satisfaits" },
      { number: "10+", label: "Années d'Expérience" },
      { number: "2", label: "Marques d'Excellence" }
    ],
    values: [
      {
        title: "Expertise Technique",
        description: "Équipe certifiée et formée aux dernières technologies"
      },
      {
        title: "Qualité & Fiabilité",
        description: "Standards élevés et respect des normes en vigueur"
      },
      {
        title: "Réactivité",
        description: "Interventions rapides et service client dédié"
      }
    ]
  },
  
  contact: {
    title: "Contactez-Nous",
    subtitle: "Parlons de Votre Projet",
    description: "Notre équipe est à votre écoute pour répondre à toutes vos questions et vous accompagner dans vos projets de déploiement réseau.",
    formFields: {
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      company: "Entreprise / Société",
      society: "Société à contacter",
      message: "Votre message",
      submit: "Envoyer le message"
    },
    societies: [
      { value: "rtconnect", label: "RT CONNECT" },
      { value: "mrtplus", label: "MRT+" },
      { value: "general", label: "Demande générale" }
    ]
  }
};
